<template>
  <section id="nosotros" class="about-section">
    <div class="container">
      <div class="row align-items-center about-row">
        <!-- Galería -->
        <div class="col-lg-6">
          <div class="about-gallery">
            <div
              class="about-image-item about-image-small"
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src="/image/familia.jpg"
                alt="Familia protegida por GM Risk"
                class="about-img"
              />
            </div>

            <div
              class="about-image-item about-image-small"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src="/image/pareja.jpg"
                alt="Pareja asesorada por GM Risk"
                class="about-img"
              />
            </div>

            <div
              class="about-image-item about-image-large"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <img
                src="/image/negocios.png"
                alt="Protección para empresas y negocios"
                class="about-large-img"
              />
            </div>
          </div>
        </div>

        <!-- Contenido -->
        <div
          class="col-lg-6"
          data-aos="fade-left"
          data-aos-delay="400"
        >
          <div class="about-content">
            <span class="about-label">Sobre nosotros</span>

            <h2 class="titulo-destacado">
              ¿Por qué GM Risk debe ser tu asesor de seguros?
            </h2>

            <p class="about-description">
              {{ aboutText }}
            </p>

            <button
              type="button"
              class="btn btn-primary about-button"
              @click="irANosotros"
            >
              Conoce más
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",

  data() {
    return {
      aboutText:
        "Ofrecemos seguros personalizados, atención profesional y cobertura nacional e internacional. Nuestra experiencia nos respalda y tu tranquilidad es nuestra prioridad."
    };
  },

  methods: {
    irANosotros() {
      this.$router.push("/sobre_nosotros");
    }
  }
};
</script>

<style scoped>
/* ==================================================
   SECCIÓN
================================================== */

.about-section {
  width: 100%;
  padding: 90px 0;
  background-color: #ffffff;
  overflow: hidden;
}

.about-row {
  row-gap: 45px;
}

/* ==================================================
   GALERÍA
================================================== */

.about-gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  width: 100%;
  max-width: 550px;
}

.about-image-item {
  position: relative;
  overflow: hidden;
  
  background-color: #edf1f5;
  box-shadow: 0 10px 30px rgba(30, 60, 99, 0.12);
}

.about-image-small {
  height: 190px;
}

.about-image-large {
  grid-column: 1 / -1;
  height: 330px;
}

.about-img,
.about-large-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.about-image-item:hover img {
  transform: scale(1.03);
}

/* ==================================================
   CONTENIDO
================================================== */

.about-content {
  max-width: 540px;
  padding-left: clamp(15px, 4vw, 65px);
}

.about-label {
  display: inline-block;
  margin-bottom: 14px;
  color: #f5ac0f;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.titulo-destacado {
  margin: 0 0 22px;
  color: #1e3c63;
  font-size: clamp(2rem, 3.2vw, 3rem);
  font-weight: 600;
  line-height: 1.15;

  word-break: normal;
  overflow-wrap: normal;
}

.about-description {
  max-width: 500px;
  margin: 0;
  color: #5d6672;
  font-size: 1.05rem;
  line-height: 1.75;

  word-break: normal;
  overflow-wrap: normal;
}

/* ==================================================
   BOTÓN
================================================== */

.about-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  margin-top: 28px;
  padding: 11px 25px;

  border: 1px solid #1e3c63;
  border-radius: 8px;
  background-color: #1e3c63;
  color: #ffffff;

  font-size: 0.95rem;
  font-weight: 500;

  transition:
    background-color 0.25s ease,
    transform 0.25s ease,
    box-shadow 0.25s ease;
}

.about-button:hover,
.about-button:focus {
  border-color: #294f7f;
  background-color: #294f7f;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(30, 60, 99, 0.2);
}

.about-button span {
  font-size: 1.15rem;
  line-height: 1;
}

/* ==================================================
   TABLETS
================================================== */

@media (max-width: 991.98px) {
  .about-section {
    padding: 70px 0;
  }

  .about-gallery {
    max-width: 100%;
  }

  .about-image-small {
    height: 220px;
  }

  .about-image-large {
    height: 360px;
  }

  .about-content {
    max-width: 100%;
    padding-left: 0;
  }

  .titulo-destacado {
    max-width: 650px;
  }

  .about-description {
    max-width: 680px;
  }
}

/* ==================================================
   CELULARES
================================================== */

@media (max-width: 767.98px) {
  .about-section {
    padding: 55px 0;
  }

  .about-row {
    row-gap: 35px;
  }

  .about-gallery {
    gap: 10px;
  }

  .about-image-item {
    border-radius: 12px;
  }

  .about-image-small {
    height: 165px;
  }

  .about-image-large {
    height: 260px;
  }

  .about-label {
    margin-bottom: 10px;
    font-size: 0.74rem;
  }

  .titulo-destacado {
    margin-bottom: 16px;
    font-size: 2rem;
    line-height: 1.18;
  }

  .about-description {
    font-size: 0.98rem;
    line-height: 1.65;
  }

  .about-button {
    margin-top: 22px;
    padding: 10px 22px;
  }
}

/* ==================================================
   CELULARES PEQUEÑOS
================================================== */

@media (max-width: 479.98px) {
  .about-section {
    padding: 45px 0;
  }

  .about-gallery {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }

  .about-image-small {
    height: 135px;
  }

  .about-image-large {
    height: 215px;
  }

  .titulo-destacado {
    font-size: 1.7rem;
  }

  .about-description {
    font-size: 0.93rem;
  }

  .about-button {
    width: 100%;
    min-height: 46px;
  }
}
</style>